import { render, staticRenderFns } from "./words.vue?vue&type=template&id=de628b78&scoped=true&"
import script from "./words.vue?vue&type=script&lang=js&"
export * from "./words.vue?vue&type=script&lang=js&"
import style0 from "./words.vue?vue&type=style&index=0&id=de628b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de628b78",
  null
  
)

export default component.exports